import { type ResponseMESF, useUTLSettingsContext } from "@dexteel/mesf-core";
import { Box, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { CenteredLazyLoading } from "../../../../../../controls/LazyLoading";
import { AgGridFooterActions } from "../../../../../../shared/data-entries/AgGridFooterActions";
import { useDataEntryContext } from "../../../context/reducer.provider";
import { useTimerContext } from "../../../context/timer.provider";
import { useEAFDataEntryActions } from "../../../hooks/useEAFDataEntryActions";
import { readProbesFromPLC } from "../../../repositories/eaf.repositories";
import { ProbeModal } from "../../modals/probe/ProbeModal";
import { useTheme } from "@mui/material/styles";
import { eafDETablesStyles } from "../styles/eafDETablesStyles";
import { useTableData } from "./hooks/useProbesTableData";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

export const TableProbes = () => {
  const theme = useTheme();
  const styles = eafDETablesStyles(theme);

  const { pause, resume } = useTimerContext();

  const {
    state: { deProcess },
    actions: { setNotificationMessage, setErrorMessage },
  } = useDataEntryContext();
  const { deleteProbe, refreshData } = useEAFDataEntryActions();

  const [showModal, setShowModal] = useState<"NEW" | "EDIT" | "">("");
  const [selectedProbe, setSelectedProbe] = useState<any>();

  const probes = deProcess?.probes;

  const readAutomaticProbes = async (value?: string) => {
    if (value === "OK") {
      const resp = await readProbesFromPLC({
        ProcessId: deProcess!.process!.ProcessId,
      });
      if (resp.ok) {
        setNotificationMessage("Read probes from PLC successful");
        await refreshData();
        return resp as ResponseMESF;
      } else {
        setErrorMessage(resp.message);
        return {
          ok: false,
          message: "Read probes from PLC failed",
        } as ResponseMESF;
      }
    } else {
      return {} as ResponseMESF;
    }
  };

  const editProbe = (ProbeId: number) => {
    pause();
    const probe = probes?.find((p) => p.ProbeId === ProbeId);
    setSelectedProbe(probe);
    setShowModal("EDIT");
  };

  const { columns } = useTableData({
    deleteProbe,
    editProbe,
  });

  return (
    <>
      <Paper>
        <Box padding={1} sx={styles.agGridBox}>
          <AgGridReact
            rowData={probes}
            columnDefs={columns}
            defaultColDef={{ ...defaultColDef, sortable: false }}
            loadingOverlayComponent={CenteredLazyLoading}
            {...defaultGridOptions}
          />
          <AgGridFooterActions
            setShowModal={setShowModal}
            readFromPLC={readAutomaticProbes}
            table="probes"
            pause={pause}
          />
        </Box>
      </Paper>
      <ProbeModal
        showModal={showModal}
        probe={selectedProbe}
        onHide={() => {
          resume();
          setShowModal("");
        }}
      />
    </>
  );
};
